import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=70b4994e"
import script from "./DetailCard.vue?vue&type=script&lang=js"
export * from "./DetailCard.vue?vue&type=script&lang=js"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=70b4994e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports